export const USER_LOGIN = 'USER_LOGIN';
export type USER_LOGIN_TYPE = typeof USER_LOGIN;

export const USER_LOGOUT = 'USER_LOGOUT';
export type USER_LOGOUT_TYPE = typeof USER_LOGOUT;
